import { render, staticRenderFns } from "./LinkedRecordFilterButton.vue?vue&type=template&id=1f7afb4c&scoped=true"
import script from "./LinkedRecordFilterButton.vue?vue&type=script&lang=js"
export * from "./LinkedRecordFilterButton.vue?vue&type=script&lang=js"
import style0 from "./LinkedRecordFilterButton.vue?vue&type=style&index=0&id=1f7afb4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7afb4c",
  null
  
)

export default component.exports